export default __webpack_public_path__ + "static/dig-logo-4918861e6278e232fac63713f7aefc74.svg";